import request from '@/utils/request'

export function selectStudentList(params) {
  return request({
    url: '/api/v1.0/student/list',
    method: 'get',
    params: params
  })
}

export function selectAllStudent() {
  return request({
    url: '/api/v1.0/student/list/all',
    method: 'get',
    params: {}
  })
}

export function selectOneStudent(sno) {
  return request({
    url: '/api/v1.0/student/select',
    method: 'get',
    params: { sno: sno }
  })
}

export function addStudent(data) {
  return request({
    url: '/api/v1.0/student/add',
    method: 'post',
    data: data
  })
}

export function updateStudent(data) {
  return request({
    url: '/api/v1.0/student/update',
    method: 'post',
    data: data
  })
}

export function deleteStudent(data) {
  return request({
    url: '/api/v1.0/student/delete',
    method: 'delete',
    data: data
  })
}

export function importStudent(file) {
  let formData = new FormData();
  formData.append('file', file.raw)
  return request({
    url: '/api/v1.0/student/import',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}


// export function deleteOneStudent(params) {
//   return request({
//     url: '/deleteStudentByNo',
//     method: 'get',
//     params: params
//   })
// }

// export function deleteMultiStudent(data) {
//   return request({
//     url: '/deleteMultipleStudent',
//     method: 'post',
//     data: data
//   })
// }

